export const MobileActions = {
    IS_MOBILE: "IS_MOBILE"
}

export const ResourcesActions = {
    RESOURCES_TOGGLE: "RESOURCES_TOGGLE"
}